export interface BaseLinkItem {
  type?: string | null
  url?: string | null
  linkRef?: { value: string; entity: string; slug?: string | null } | string | null
  openInNewTab?: boolean | null
}

export const MAIN_MENU_CODE = 'main-header'
export const HORIZONTAL_MENU_CODE = 'Horizontal_Menu'

export function resolveNavLink(link?: BaseLinkItem | null): { url: string; isExternal: boolean } {
  if (!link) {
    return { url: '#', isExternal: false }
  }

  const isExternal = !!link.openInNewTab

  // If it's an internal reference from CMS (page, category, product, etc)
  if (link.type && link.linkRef) {
    const linkValue = typeof link.linkRef === 'object' ? link.linkRef.value : link.linkRef
    const linkEntity = typeof link.linkRef === 'object' ? link.linkRef.entity : link.type
    const linkSlug = typeof link.linkRef === 'object' ? link.linkRef.slug : null

    if (linkEntity === 'category') {
      return { url: `/categories/${linkValue}`, isExternal }
    }
    if (linkEntity === 'product') {
      return { url: `/products/${linkValue}`, isExternal }
    }

    // Default for 'page' or others — prefer slug for SEO-friendly URLs, fall back to id
    if (linkSlug) {
      return { url: `/${linkSlug}`, isExternal }
    }
    return { url: `/pages/${linkValue}`, isExternal }
  }

  // Fallback to URL
  if (link.url) {
    return { url: link.url, isExternal: link.url.startsWith('http') ? true : isExternal }
  }

  return { url: '#', isExternal: false }
}

export const MEGA_MENU_PT = {
  root: { className: 'p-megamenu p-megamenu-vertical w-full' },
  menu: { className: 'p-megamenu-root-list flex flex-col text-sm text-foreground' },
  menuButton: { className: 'hidden' },
  menuitem: {
    className: `p-menuitem relative group aria-expanded:bg-secondary/10`,
  },
  content: { className: 'p-menuitem-content w-full flex' },
  label: { className: 'p-menuitem-text flex-1' },
  action: {
    className:
      'p-menuitem-link flex flex-1 items-center space-between w-full pl-4 pr-2 py-4 text-base font-semibold text-capitalize hover:bg-secondary/5 cursor-pointer',
  },
  panel: {
    className: 'p-megamenu-panel bg-background border border-secondary/10 shadow-lg min-w-48',
  },
  grid: { className: 'p-megamenu-grid flex w-full p-3' },
  column: { className: 'p-megamenu-col-12 w-full' },
  submenu: {
    className: 'p-submenu-list p-megamenu-submenu flex flex-col gap-1 text-sm text-foreground',
  },

  submenuItem: { className: 'p-menuitem' },
}

export const MEGA_MENU_PT_HORIZONTAL = {
  root: { className: 'p-megamenu p-megamenu-horizontal flex-1 min-w-0' },
  menu: {
    className: 'p-megamenu-root-list flex flex-wrap items-center gap-6 text-sm text-foreground',
  },
  menuButton: { className: 'hidden' },
  menuitem: {
    className: `p-menuitem pl-2 relative group aria-expanded:bg-secondary/10`,
  },
  content: { className: 'p-menuitem-content flex' },
  label: { className: 'p-menuitem-text' },
  action: {
    className:
      'p-menuitem-link flex items-center gap-1 py-2 font-medium text-foreground hover:text-primary transition-colors cursor-pointer whitespace-nowrap',
  },
  panel: {
    className:
      'p-megamenu-panel bg-background border border-secondary/10 shadow-lg rounded-b-md min-w-52 z-50',
  },
  grid: { className: 'p-megamenu-grid flex p-3' },
  column: { className: 'p-megamenu-col-12 min-w-48' },
  submenu: { className: 'p-submenu-list p-megamenu-submenu flex flex-col gap-1 py-1 group' },
  submenuIcon: {
    className: 'p-submenu-icon w-4 h-4 ml-1 opacity-60',
  },
  submenuHeader: { className: 'p-megamenu-submenu-header hidden' },
  submenuItem: { className: 'p-menuitem' },
}
